const cloudflareFallbackURLs = [
    "https://www.jori.com/cdn-cgi/trace",
    'https://one.one.one.one/cdn-cgi/trace',
    'https://1.0.0.1/cdn-cgi/trace',
    'https://cloudflare-dns.com/cdn-cgi/trace',
    'https://cloudflare-eth.com/cdn-cgi/trace',
    'https://cloudflare-ipfs.com/cdn-cgi/trace',
    'https://workers.dev/cdn-cgi/trace',
    'https://pages.dev/cdn-cgi/trace',
    'https://cloudflare.tv/cdn-cgi/trace'
];

export type CloudfareValues = {
    loc: string
}

// Adapted from:
// https://stackoverflow.com/questions/32455180/get-cloudflares-http-cf-ipcountry-header-with-javascript
export async function getCloudflareValues(): Promise<CloudfareValues> {
    let data = await fetchWithFallback(cloudflareFallbackURLs).then(res=> {
        if(res) {
            return res.text()
        } else {
            return undefined;
        }
    });
    let arr = data ? data.trim().split('\n').map(e=>e.split('=')) 
                   : [];
    return Object.fromEntries(arr);
}

async function fetchWithFallback(links: string[], obj?: RequestInit) {
    let response;
    for (let link of links) {
        try {
            response = await fetch(link, obj);
            if (response.ok) {
                return response
            }
        } catch (e) {

        }
    }
    return response
}